module.exports = __webpack_public_path__ + "static/gallery_wild_5-dc45222c5acb5cc9a7cd90b10a7f65ac.jpg";